import { BillingRegAccountPage, BillingRegRRNPage } from '#pages';
import useFunnelFormProvider from 'src/refactor_shared/hooks/useFormProvider';
import useFunnel from 'src/refactor_shared/hooks/useFunnel';

const Billing = () => {
  const { Funnel, Step, setCurrentFunnelStep } = useFunnel('resident');

  const { FunnelFormProvider } = useFunnelFormProvider({});

  return (
    <FunnelFormProvider>
      <Funnel>
        <Step step="resident">
          <BillingRegRRNPage setStep={setCurrentFunnelStep} />
        </Step>
        <Step step="accountInfo">
          <BillingRegAccountPage setStep={setCurrentFunnelStep} />
        </Step>
      </Funnel>
    </FunnelFormProvider>
  );
};

export default Billing;
